import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'SELECT_DOC',
  title: 'Wie wählt man die benötigten Dokumente aus?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf den Registerkarte "Projekte"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SELECT_DOC/DE_SELECT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf das Projekt Ihrer Wahl'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SELECT_DOC/DE_SELECT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Klicken Sie auf die 3 Punkte oben rechts'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SELECT_DOC/DE_SELECT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Klicken Sie auf "Anforderliche Dokumente anzeigen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SELECT_DOC/DE_SELECT_DOC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Wählen Sie die Dokumente aus, die gesammelt werden sollen und die im Projekt Ordner benötigt werden'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SELECT_DOC/DE_SELECT_DOC_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Klicken Sie auf Weiter zur bestätigen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SELECT_DOC/DE_SELECT_DOC_6.png`
  }]
};
